(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cbm-mystery-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const states = new Map();
  const allowed = (state) => state.visible && (!state.slide || state.slide.classList.contains('is-selected')) && !document.hidden && !reduced.matches;
  const sync = async (video, state) => {
    if (!allowed(state)) { video.pause(); return; }
    if (state.pending || state.blocked || !video.paused) return;
    if (!video.src) video.src = video.dataset.src;
    video.muted = true;
    state.pending = true;
    try {
      await video.play();
      if (!allowed(state)) video.pause();
    } catch (error) {
      state.blocked = allowed(state) && error.name !== 'AbortError';
    } finally {
      state.pending = false;
    }
  };
  const refresh = () => states.forEach((state, video) => sync(video, state));
  const slides = new MutationObserver(refresh);
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting, intersectionRatio }) => {
      const state = states.get(target);
      state.visible = isIntersecting && intersectionRatio >= .15;
      sync(target, state);
    });
  }, { threshold: .15 });
  const init = (root) => root.querySelectorAll('video[data-cbm-motion]').forEach((video) => {
    if (states.has(video)) return;
    const state = { visible: false, slide: video.closest('.product-images__slide') };
    states.set(video, state);
    video.addEventListener('playing', () => {
      if (!allowed(state)) { video.pause(); return; }
      state.blocked = false;
      video.classList.add('is-playing');
    });
    video.addEventListener('error', () => video.classList.remove('is-playing'));
    observer.observe(video);
    if (state.slide) slides.observe(state.slide, { attributes: true, attributeFilter: ['class'] });
  });
  document.addEventListener('visibilitychange', refresh);
  reduced.addEventListener('change', refresh);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => states.forEach((state, video) => {
    if (!event.target.contains(video)) return;
    video.pause(); observer.unobserve(video); states.delete(video);
  }));
  init(document);
})();
  } catch(e) { console.error(e); }
})();

})();
